export enum SegmentConnectionTypes {
  TOTAL = 'segment-total',
  SCALE = 'segment-scale',
  TECHNICAL_STOP = 'segment-technical-stop'
}

export enum ProvidersExcludedFromDuration {
  VIVA_COLOMBIA = 'VivaColombia'
}
